export const dateFormat = 'YYYY-MM-DD';
export const positiveSentimentColor = '#4caf50';
export const neutralSentimentColor = '#ff9800';
export const negativeSentimentColor = '#f44336';
export const remainderSentimentColor = '#555555';
export const defaultDateRangeDays = '30'; // days